import { useEffect, useRef } from "react";

// "Ask the lesson bar now": a page that learns something the student's lesson bar polls for (a genomgång
// ended) tells the bar instead of waiting for its next tick (LektionsBarForElev).
export const AKTIV_LEKTION_NU = "vektr:aktiv-lektion-nu";

export function fragaAktivLektionNu(): void {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(AKTIV_LEKTION_NU));
}

/** For an activity page whose own poll follows the activity (the bar waits 30 s there): tells the bar the moment
 *  the activity it has seen running ends, so the next one the teacher starts is offered without that wait. */
export function useMeddelaAktivitetensSlut(slut: boolean): void {
  const sagIgang = useRef(false);
  useEffect(() => {
    if (!slut) sagIgang.current = true;
    else if (sagIgang.current) {
      sagIgang.current = false;
      fragaAktivLektionNu();
    }
  }, [slut]);
}
